export default class ImageFormEnteteController {
	static $inject = [
		'$scope',
		'$state',
		'$stateParams',
		'ImagesService',
		'ImagesTypesService',
		'ModalService',
		'notification',
		'$translate',
		'Upload',
		'CodeAutomatiqueService'
	];

	constructor(
		$scope,
		$state,
		$stateParams,
		ImagesService,
		ImagesTypesService,
		ModalService,
		notification,
		$translate,
		Upload,
		CodeAutomatiqueService
	) {
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.ImagesService = ImagesService;
		this.ImagesTypesService = ImagesTypesService;
		this.ModalService = ModalService;
		this.notification = notification;
		this.$translate = $translate;
		this.Upload = Upload;
		this.Progression = 0;
		this.fileTooBig = false;
		this.CodeAutomatiqueService = CodeAutomatiqueService;
	}

	async $onInit() {
		this.image = this.image || {};
		this.entete = this.image.entete;
		this.types = this.types || [];
		this.fichier = [];
		this.isCodeVisible = true;
		this.isAutoCodeEnabled = await this.isCodeAuto();
		await this.getNiveauVisibilite();
		await this.getImageFromServer();
	}

	async getNiveauVisibilite() {
		if (this.entete.idType) {
			this.entete.niveauVisibilite = await this.ImagesTypesService.GetNiveauVisibilite(this.entete.idType);
		}
	}

	$onChanges(objChanges) {
		if (objChanges.image) {
			this.getTypes();
		}
	}

	// $doCheck() {
	// 	if (!angular.equals(this.entete, this.image.entete)) {
	// 		this.onUpdate({
	// 			entete: angular.copy(this.entete)
	// 		});
	// 	}
	// }

	async onFileSelect($files) {
		this.entete.file = $files;

		if (!this.entete.file || !this.entete.file[0]) return;

		this.fileTooBig = false;

		const fr = new FileReader();

		fr.onload = () => {
			const img = new Image();

			img.onload = async () => {
				this.entete.imgWidth = img.width;
				this.entete.imgHeight = img.height;
				this.entete.imgSize = this.entete.file[0].size;
				if (!this.entete.isValid()) {
					this.checkValidity();
				}
				this.$scope.$apply();
				if (!this.fileTooBig) {
					try {
						this.startLoading();
						await this.ImagesService.onFileSelect(this.entete.file, this.image.id, this.image.entete.code);
						await this.onUpdateImage();
					} catch (ex) {
						this.notification.error(ex.data);
					} finally {
						this.stopLoading();
						this.resetFileInput();
					}
				}
			};

			img.src = fr.result;
		};

		fr.readAsDataURL(this.entete.file[0]);
	}
	checkValidity() {
		let validity = true;
		if (!this.entete.isValid()) {
			validity = false;
			this.$scope.$broadcast('imageValidations');
		}
		this.fileTooBig = this.entete?.$errors?.downloadFile?.includes('FILE_TOO_LARGE');

		return validity;
	}
	resetFileInput() {
		this.entete.file = [];
		const downloadInput = document.getElementById('downloadFile');
		if (downloadInput) {
			downloadInput.value = '';
		}
	}
	async createType() {
		const modalInstance = this.ModalService.confirm({
			modalTitle: 'IMAGES.CONFIRM_CREATE_TYPE.TITLE',
			modalMsg: 'IMAGES.CONFIRM_CREATE_TYPE.MESSAGE',
			headerClass: 'modal-warning'
		});
		modalInstance.result.then(() => this.$state.go('images.newType'));
	}

	async getTypes() {
		this.startLoading();

		try {
			this.types = await this.ImagesTypesService.getAll();
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async checkCodeUnicity(code) {
		if (code) {
			this.startCodeLoading();

			try {
				if (code.match(/^[a-zA-Z0-9_|]*$/)) {
					this.entete.codeExists = await this.ImagesService.codeExists(code);
				}
			} catch (ex) {
				this.notification.error(ex.data);
			} finally {
				this.stopCodeLoading();
			}
		} else {
			this.entete.codeExists = null;
		}
	}

	async getImageFromServer() {
		this.imageFile = await this.ImagesService.getShowImage(this.image.entete.source, this.image.entete.extension, this.image.entete.code);
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}

	startCodeLoading() {
		this.codeLoading = true;
	}

	stopCodeLoading() {
		this.codeLoading = false;
	}

	async isCodeAuto() {
		const codeAutoObject = (await this.CodeAutomatiqueService.getCodeAutomatique('gestion')).find((c) => c.domaineCode === 'Images');
		if (codeAutoObject?.estCodeAutomatique) {
			this.isCodeVisible = codeAutoObject.estCodeAffiche;
			this.image.entete.isCodeAutoEnabled = codeAutoObject.estCodeAutomatique;
			return codeAutoObject.estCodeAutomatique;
		}
		return false;
	}
}
